"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const DataProvider_1 = tslib_1.__importDefault(require("../DataProvider"));
exports.isSubscriptionLevelWarningMessageDetails = (details) => details !== null && details.type === "subscription_level_warning";
class SubscriptionLevelProvider extends DataProvider_1.default {
    get fragments() {
        return {
            SubscriptionLevel: () => `
        ... on SubscriptionLevel {
          id
          userId
          user {
            ${this.getFragment("UserPublicData")}
          }          
          pricePackageId
          pricePackage {
            ${this.getFragment("PaymentPackage")}
          }
          description
          disabled
        }
      `,
        };
    }
    find({ userIds }, fields) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const res = (yield this.query("subscriptionLevelFind", { userIds }, this.getFragment("SubscriptionLevel", fields)));
            return res.sort((a, b) => {
                var _a, _b, _c, _d;
                return (_b = (_a = a.pricePackage) === null || _a === void 0 ? void 0 : _a.amount, (_b !== null && _b !== void 0 ? _b : Number.MAX_VALUE)) - (_d = (_c = b.pricePackage) === null || _c === void 0 ? void 0 : _c.amount, (_d !== null && _d !== void 0 ? _d : Number.MAX_VALUE));
            });
        });
    }
    create({ data }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.mutate("subscriptionLevelCreate", { data }, this.getFragment("SubscriptionLevel"));
        });
    }
    update({ data }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.mutate("subscriptionLevelUpdate", { data }, this.getFragment("SubscriptionLevel"));
        });
    }
    delete({ id }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.mutate("subscriptionLevelDelete", { id });
        });
    }
    findByIds({ ids }, fields) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.query("subscriptionLevelFindByIds", { ids }, this.getFragment("SubscriptionLevel", fields));
        });
    }
}
exports.SubscriptionLevelProvider = SubscriptionLevelProvider;
//# sourceMappingURL=SubscriptionLevelProvider.js.map